import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { SectionHeading, Watermark } from '../components/Section';
import { standards } from '../data/mock';
import SEO from '../lib/SEO';

export default function Standards() {
  return (
    <div className="font-sans-body">
      <SEO />
      <section className="relative overflow-hidden">
        <Watermark opacity={0.04} />
        <div className="container-aqc relative py-16 lg:py-20 text-center">
          <span className="eyebrow">Standards & Certifications</span>
          <h1 className="mt-5 font-serif text-[2.4rem] sm:text-[3rem] leading-[1.08] font-semibold text-aqc-navy max-w-3xl mx-auto">
            Aligned to <span className="italic text-aqc-red">International Standards.</span>
          </h1>
          <p className="mt-6 text-aqc-muted max-w-2xl mx-auto">
            AQC works with laboratories and inspection bodies that carry these accreditations and applies these standards in its work.
          </p>
        </div>
      </section>

      <section className="py-12 bg-aqc-cream">
        <div className="container-aqc">
          <div className="overflow-x-auto rounded-2xl border border-aqc-line bg-white shadow-sm">
            <table className="w-full text-left border-collapse">
              <caption className="sr-only">Standards and certifications applied by Apex Quality Control</caption>
              <thead>
                <tr className="bg-aqc-navy text-white text-[0.72rem] uppercase tracking-[0.14em] font-semibold">
                  <th scope="col" className="px-5 py-4 font-semibold w-1/4">Standard</th>
                  <th scope="col" className="px-5 py-4 font-semibold w-1/4">Name</th>
                  <th scope="col" className="px-5 py-4 font-semibold w-1/3">Description</th>
                  <th scope="col" className="px-5 py-4 font-semibold">Applies to</th>
                </tr>
              </thead>
              <tbody>
                {standards.map((s, idx) => (
                  <tr key={s.code} className={`${idx % 2 === 0 ? 'bg-white' : 'bg-aqc-cream/60'} border-t border-aqc-line align-top`}>
                    <th scope="row" className="px-5 py-4 font-serif text-aqc-red font-semibold whitespace-nowrap">{s.code}</th>
                    <td className="px-5 py-4 text-aqc-navy font-medium">{s.name}</td>
                    <td className="px-5 py-4 text-aqc-muted text-[0.94rem]">{s.desc}</td>
                    <td className="px-5 py-4 text-aqc-ink/80 text-[0.9rem]">{s.applies}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container-aqc text-center">
          <h2 className="font-serif text-3xl text-aqc-navy">Need a specific standard? Contact us.</h2>
          <div className="mt-6">
            <Link to="/contact"><Button className="bg-aqc-navy hover:bg-[hsl(var(--aqc-navy-2))] text-white h-11 px-6">Contact our team</Button></Link>
          </div>
        </div>
      </section>
    </div>
  );
}
